import { BootAuthResponse } from "../types";

class FeatureFlagService {
    private featureFlags: Record<string, boolean> = {};

    initialize(authBoot: BootAuthResponse) {
        this.featureFlags = authBoot.featureFlags;
    }

    isEnabled(featureFlag: string) {
        return this.featureFlags[featureFlag] ?? false;
    }
}

export const featureFlagService = new FeatureFlagService();